
export const baseURL = "https://crmred.co/"
export const settings = {
  some: 'Settings'
}
